import { z } from 'zod';
const text = (min, max) => z.string().trim().min(min).max(max);
const revision = z.number().int().positive().max(Number.MAX_SAFE_INTEGER);
/** A small conversational brief, not an agreed scope or implementation specification. */
export const IntakePlaybookSchema = z.object({
    title: text(4, 100),
    problem: text(10, 1200),
    desiredOutcome: text(10, 1000),
    actions: z.array(z.object({ title: text(4, 100), detail: text(10, 800) }).strict()).min(1).max(3),
    offering: z.object({
        id: z.enum(['growth-suite', 'the-forge', 'bos-ai', 'undetermined']),
        reason: text(10, 600),
    }).strict(),
    assumptions: z.array(text(5, 400)).max(4),
}).strict();
export const IntakePlaybookUpdatedSchema = z.object({ revision, playbook: IntakePlaybookSchema }).strict();
/** Emitted only by the server after current browser-confirmed contact and consent. */
export const IntakePlaybookReadySchema = z.object({
    revision,
    contactRevision: z.number().int().nonnegative().max(Number.MAX_SAFE_INTEGER),
    preparedFor: z.object({ name: text(1, 120), organisation: text(1, 160) }).strict(),
    playbook: IntakePlaybookSchema,
}).strict();
//# sourceMappingURL=intake-playbook.js.map